// Shared style tokens & small style factories used by HUD subcomponents.
import { COLORS } from "../constants";

export const pill = {
  background: "rgba(11,21,48,0.65)",
  border: `1px solid ${COLORS.navyMid}`,
  borderRadius: 999,
  backdropFilter: "blur(8px)",
};

export const panelBox = {
  background: "rgba(11,21,48,0.65)",
  border: `1px solid ${COLORS.navyMid}`,
  borderRadius: 12,
  backdropFilter: "blur(8px)",
};

export const eyebrow = {
  color: COLORS.gold,
  fontSize: 10,
  letterSpacing: 3,
  textTransform: "uppercase",
};

export const fontSerif = "Georgia, 'Times New Roman', serif";
